import Config from '@config';
import { initializeMainOrganizationApi } from '@gasbi/shared/common/features/mainOrganization';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  mainOrganizationApi,
  useGetMainOrganizationByIdQuery,
  useGetMainOrganizationsQuery,
  useGetMainOrganizationQuery,
  useCreateMainOrganizationMutation,
  useUpdateMainOrganizationByIdMutation,
  useAssignAdministratorMutation,
  useUnassignAdministratorMutation,
  useGetMainOrganizationRolesInfiniteQuery,
  useGetCachedRoleByIdSelector,
} = initializeMainOrganizationApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});
